import { reactive } from "vue";

export const productState = reactive({
  currentPattern: undefined,
  currentSize: undefined,
  currentSettingTab: "UV Lacquer",
});
